module.exports = __webpack_public_path__ + "img/sub_main_ceo.605dd83b.png";